import { Controller } from '@hotwired/stimulus';
import { hide, show } from '@frontend/utils/dom';
import {
  subscribeCustomEvent,
  unsubscribeCustomEvent,
} from '@frontend/utils/events';

export default class extends Controller {
  static targets = ['linkToArchive'];

  connect() {
    hide(this.linkToArchiveTarget);
    this.boundHandleArticleTeaserIndexNoMoreItems =
      this.handleArticleTeaserIndexNoMoreItems.bind(this);
    subscribeCustomEvent(
      'article-teaser-index:no-more-items',
      this.boundHandleArticleTeaserIndexNoMoreItems
    );
  }

  disconnect() {
    unsubscribeCustomEvent(
      'article-teaser-index:no-more-items',
      this.boundHandleArticleTeaserIndexNoMoreItems
    );
  }

  handleArticleTeaserIndexNoMoreItems() {
    show(this.linkToArchiveTarget);
  }
}
